import { ItemProductSearchFilterDefaultsFragment } from "../../products/productSearchFilters.generated.js";
import {
  isAnyFilterSet,
  ProductFiltersFormValues,
} from "../../products/filters/ProductFilterFields.js";
import { definitionsToFormValues } from "../../products/helper.js";

/** Placeholder defaults only: the selected product's type/brand must not constrain the alternatives. */
export function getAlternativesFilters(
  defaults: ItemProductSearchFilterDefaultsFragment,
  placeholder?: { productTypeKey: string } | null
): ProductFiltersFormValues | undefined {
  const defaultFilters = definitionsToFormValues(defaults);
  const filters = placeholder
    ? { ...defaultFilters, productTypeKeys: [placeholder.productTypeKey] }
    : defaultFilters;
  return isAnyFilterSet(filters) ? filters : undefined;
}
